import {Injectable} from '@angular/core';
import {DatePipe} from '@angular/common';

@Injectable({providedIn: 'root'})
export class TransactionTermService {

  constructor(private datePipe: DatePipe) {
  }

  /**
   * Given a terms lookup array, a selected term_id, and an invoice/header date,
   * returns the calculated due date as a formatted string (yyyy-MM-ddTHH:mm:ss).
   * Uses loose equality (==) to handle string/number type mismatches from the API.
   */
  calculateDueDate(terms: any[], termId: any, headerDate: any): string | null {
    if (!termId || !headerDate) {
      return null;
    }
    const termMatch = terms?.find(x => x.id == termId);
    const daysDue = termMatch?.due_days ?? 0;
    const tempDate = new Date(headerDate);
    tempDate.setDate(tempDate.getDate() + daysDue);
    return this.datePipe.transform(tempDate, 'yyyy-MM-ddTHH:mm:ss');
  }
}
